import { Box, makeStyles } from '@material-ui/core';
import { unitPriceFormatter } from 'utils/helpers';

const sizes = {
  small: 12,
  medium: 14,
  large: 16,
};
const sizes_mobile = {
  small: 9.5,
  medium: 11,
  large: 13,
};

const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: ({ size }) => sizes[size] || size,
    lineHeight: '20px',
    color: theme.palette.colors.grey500,
    fontWeight: 600,

    [theme.breakpoints.down('xs')]: {
      fontSize: ({ size, view }) =>
        view !== 'desktop' && (sizes_mobile[size] || size),
      lineHeight: ({ view }) => view !== 'desktop' && '13px',
    },
  },
  sup: {
    position: 'relative',
    top: 3,
    fontSize: 7,
    lineHeight: 1,
    marginRight: 2,
  },
}));

const PricePerUnit = (props) => {
  const { amount, view, size = 'small' } = props;
  const classes = useStyles({ size, view });

  return (
    <Box className={classes.root}>
      <sup className={classes.sup}>$</sup>
      {amount?.length ? unitPriceFormatter(amount) : null}
    </Box>
  );
};

export default PricePerUnit;
